var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "plan-modal",
    attrs: {
      title: (_vm.isEdit.length ? _vm.$t("编辑") : _vm.$t("添加")) + _vm.$t("进度"),
      visible: _vm.visible,
      width: 820
    },
    on: {
      cancel: e => _vm.closeAddVisible(e)
    }
  }, [_c("a-form-model", {
    ref: "addPlanFormRef",
    attrs: {
      model: _vm.addPlanForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("进度名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addPlanForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.addPlanForm, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addPlanForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("展示icon"),
      prop: "iconName"
    }
  }, [_c("icon-list", {
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto"
    },
    attrs: {
      name: _vm.addPlanForm.iconName
    },
    on: {
      iconOk: _vm.iconValue
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticClass: "marginR15",
    staticStyle: {
      width: "60px"
    },
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]), !_vm.isEdit.length ? _c("a-checkbox", {
    attrs: {
      checked: _vm.continueState
    },
    on: {
      change: _vm.onContinueToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("继续添加")))]) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };